import {ObvioEvent} from 'Event'
import {useEvents} from 'lib/event-api/organization/use-events'
import {PurchasePage} from 'Event/Marketplace/purchase-page'
import {marketplaceApi} from 'lib/marketplace-api/url'
import {client} from 'lib/ui/api-client'
import {useOrganization} from 'organization/OrganizationProvider'
import {useQuery} from 'react-query'
import {UpsellPage} from 'Event/Marketplace/upsell-page'

export type EventWithUpsellPage = ObvioEvent & {
  upsellPageTemplate: UpsellPage['template']
}

export function useUpsellPageEvents() {
  const {organization} = useOrganization()
  const {data: events} = useEvents()

  return useQuery({
    queryKey: ['organizations', organization.id, 'upsell_page_events'],
    queryFn: () =>
      new Promise<EventWithUpsellPage[]>(async (resolve) => {
        if (!events) {
          resolve([])
          return
        }

        const UpsellPages = events.map(async (event) => {
          const UpsellPage = await client.get<PurchasePage | null>(
            marketplaceApi(`/events/${event.id}/upsell_page`),
          )

          if (!UpsellPage?.template) {
            return null
          }

          const hasSections = Boolean(UpsellPage.template.sections)
          if (!hasSections) {
            return null
          }

          return {
            ...event,
            upsellPageTemplate: UpsellPage.template,
          }
        })

        const result = (await Promise.all(UpsellPages)).filter(
          (UpsellPage) => UpsellPage,
        ) as EventWithUpsellPage[]

        resolve(result)
      }),
    enabled: !!events,
  })
}
